enum InterestDaysInYear {
    Actual365 = "ACTUAL_365",
    Actual360 = "ACTUAL_360",
}
export default InterestDaysInYear